import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { BlankSlate, Box, Button } from '@factorialco/deprecated-design-system'
import { CanCreateTeamsDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  show: boolean
}

const BlankSlateTeams = ({ show }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { data } = useQuery(CanCreateTeamsDocument)

  if (!show) {
    return null
  }

  const canCreateTeams = Boolean(data?.teams._policies.teamCreate.can)

  const onOpenCreateTeam = () => {
    navigate(navigation.employees.teams.list.add.fullPath())
  }

  const onOpenImportTeams = () => {
    navigate(navigation.employees.teams.importTeams.fullPath())
  }

  return (
    <BlankSlate
      illustration="group"
      title={i18n.t('teams.blank_slate.title')}
      description={i18n.t('teams.blank_slate.description')}
    >
      {canCreateTeams && (
        <Box flexDirection="row" justifyContent="center" gap="s8">
          <>
            <Button type="secondary" iconName="upload" onClick={onOpenImportTeams}>
              {i18n.t('teams.import.title')}
            </Button>

            <Button type="primary" iconName="add" onClick={onOpenCreateTeam}>
              {i18n.t('teams.add')}
            </Button>
          </>
        </Box>
      )}
    </BlankSlate>
  )
}

export default BlankSlateTeams
